import type { FormConfig } from '../form-engine.js';
import { VERTICAL_KEYS } from '../vertical.js';
import { imobiliarioGeralFormConfig } from './imobiliario-geral.js';
import { mcmvFormConfig } from './mcmv-imobiliario.js';
import { protecaoVeicularFormConfig } from './protecao-veicular.js';

// =============================================================================
// Registry of FormConfig per vertical. The FE looks the right one up by the
// broker's verticalKey (returned in /public/broker/:subdomain). MCMV is the
// fallback when the key is missing · legacy brokers without verticalId.
// =============================================================================

const REGISTRY = new Map<string, FormConfig>([
  [VERTICAL_KEYS.MCMV_IMOBILIARIO, mcmvFormConfig],
  [VERTICAL_KEYS.PROTECAO_VEICULAR, protecaoVeicularFormConfig],
  [VERTICAL_KEYS.IMOBILIARIO_GERAL, imobiliarioGeralFormConfig],
]);

export function getFormConfig(verticalKey: string | undefined): FormConfig {
  if (!verticalKey) return mcmvFormConfig;
  return REGISTRY.get(verticalKey) ?? mcmvFormConfig;
}

export { imobiliarioGeralFormConfig, mcmvFormConfig, protecaoVeicularFormConfig };
